import clsx from 'clsx';
import React from 'react';
import { MdContentCopy } from 'react-icons/md';
import Txt from 'components/atoms/Txt/Txt';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import classes from './Copyable.qmee.module.scss';
import type { CopyableProps } from './Copyable.types';

const Copyable: React.FC<CopyableProps> = ({
  clipboardValue,
  title = 'code',
  displayValue,
  className,
  onClick,
}) => {
  const displayText = displayValue ?? clipboardValue;
  const [text, setText] = React.useState<string | React.ReactNode>(displayText);

  const { handleCopy } = useCopyToClipboard(clipboardValue, {
    onSuccess: () => {
      setText(<Txt>Copied to clipboard!</Txt>);
      setTimeout(() => {
        setText(displayText);
      }, 1500);
    },
  });

  function handleCopyClick() {
    handleCopy();
    onClick?.();
  }

  return (
    <button className={clsx(classes.root, className)} onClick={handleCopyClick} type="button">
      <Txt className={classes.label} size="small" color="primary">
        Copy {title}:
      </Txt>
      <Txt className={classes.text} skipTranslation>
        {text}
      </Txt>
      <MdContentCopy className={classes.icon} />
    </button>
  );
};

export default Copyable;
